<div class="drop-file-container">
  <div class="drop-file-content">
    <div class="upload-icon">
      <u-icon [model]="{ type: 'font', value: 'pi pi-cloud-upload' }" [styles]="{ fontSize: '14px' }"></u-icon>
    </div>
    <span class="drop-text">Drop your files here</span>
  </div>
</div>
